import { useEffect, useRef, useState } from "react";
import lodash from "lodash";
import CustomModal from "../CustomModal";
import CommonReportActionHeader from "../CommonReport/CommonReportActionHeader";
import { StyledReportContainer } from "../CommonReport/styles";
import exportComponentAsPDF from "@/util/export_file";

const BlockSuggestionPopup = ({
  showBlockSuggestion,
  setShowBlockSuggestion,
  data,
  setData,
}) => {
  const [tableData, setTableData] = useState([]);
  const blockSuggestionRef = useRef();

  useEffect(() => {
    if (data) {
      const groupedData = lodash.groupBy(data, "cell");
      const formattedData = Object.keys(groupedData).map((cell) => ({
        cell: cell,
        block: groupedData[cell][0].block,
        inmates: groupedData[cell].map(
          ({ fname, mname, lname, arrestDate }) => ({
            fname,
            mname,
            lname,
            arrestDate,
          })
        ),
        totalBeds: groupedData[cell].length,
      }));

      setTableData(formattedData);
    }
  }, [data]);

  return (
    <CustomModal
      show={showBlockSuggestion}
      hideSavebutton
      onHide={() => {
        setShowBlockSuggestion(false);
        setData([]);
      }}
      size="xl"
    >
      <CommonReportActionHeader
        onClose={() => {
          setShowBlockSuggestion(false);
          setData([]);
        }}
        onExportClick={() => {
          exportComponentAsPDF(blockSuggestionRef, "block-suggestion.pdf");
        }}
      />
      <StyledReportContainer ref={blockSuggestionRef}>
        <table className="table-default">
          <thead>
            <tr>
              <th>Last Name</th>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Arrest Date</th>
              <th>Housing Assignment Block</th>
              <th>Housing Assignment Cell</th>
              <th>Housing Assignment Bed</th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((item) => (
              <>
                <tr className="table-inner-header">
                  <td colSpan={20}>{item?.cell}</td>
                </tr>
                {item?.inmates.map((inmates) => (
                  <tr>
                    <td>{inmates?.lname}</td>
                    <td>{inmates?.fname}</td>
                    <td>{inmates?.mname}</td>
                    <td>{inmates?.arrestDate}</td>
                    <td>{item?.block}</td>
                    <td>{item?.cell}</td>
                    <td>{inmates?.bed}</td>
                  </tr>
                ))}
                <tr className="inner-total-row">
                  <td colSpan={20}>
                    <span>Total For:</span> {item?.totalBeds}
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
        <div className="table-total-row">
          Total Number of Rows: {data?.length}
        </div>
      </StyledReportContainer>
    </CustomModal>
  );
};

export default BlockSuggestionPopup;
